export default "__VITE_ASSET__D$huqZqA__"